import SettingsConfig from "../../Config/Settings/SettingsConfig";
import Settings from "../../Entity/Settings/Settings";
import crudApi from "@serie3/common/api/crudApi";
import ToastMessages from "@serie3/freelancesplaceapi/Domain/Shared/ToastMessages";

const createSettingsForm = (setSettings) => {
  const onSubmit = async (values) => {
    const response = await crudApi.edit(SettingsConfig.endpoints.edit, JSON.stringify(values));
    if (response.status === 200) {
      if (setSettings) setSettings(response.data.Settings?.[0] ?? values);
      ToastMessages.SuccessfulSave();
    } else {
      ToastMessages.Error();
    }
  };

  return {
    initialValues: Settings,
    onSubmit: (values) => onSubmit(values),
  };
};

const setEditData = (data) => ({
  id: data.id,
  locale: data.locale || "",
});

export default { createSettingsForm, setEditData };
